export const servicesText = {
  en: {
    heading: "If you’re someone who…",
    services: [
      {
        title: "Career Starters (Students & Young Adults)",
        desc: [
          "Discover strengths, personality, and interests",
          "Explore suitable study paths & career options",
          "Build clarity and confidence in decision-making",
          "Create a simple roadmap to begin your career journey",
        ],
      },
      {
        title: "Career Returners (Mothers & Migrants)",
        desc: [
          "Identify transferable skills and new opportunities",
          "Rebuild confidence after a career break",
          "Choose roles that fit your lifestyle and values",
          "Get support with CV, interviews, and re-entry planning",
        ],
      },
      {
        title: "Career Changers (Mid-Life Adults)",
        desc: [
          "Reassess your values, strengths, and life priorities",
          "Explore meaningful, realistic new career directions",
          "Plan a sustainable transition for the next 10–15 years",
          "Realign work with who you are now",
        ],
      },
    ],
  },

  vi: {
    heading: "Nếu bạn đang là người…",
    services: [
      {
        title: "Bắt Đầu Sự Nghiệp (Sinh viên & Người trẻ)",
        desc: [
          "Khám phá điểm mạnh, tính cách và sở thích",
          "Tìm hiểu lộ trình học tập và nghề nghiệp phù hợp",
          "Xây dựng sự rõ ràng và tự tin khi ra quyết định",
          "Tạo lộ trình đơn giản để bắt đầu hành trình sự nghiệp",
        ],
      },
      {
        title: "Quay Lại Sự Nghiệp (Mẹ & Người Nhập Cư)",
        desc: [
          "Nhận diện kỹ năng chuyển đổi và cơ hội mới",
          "Xây dựng lại sự tự tin sau thời gian gián đoạn",
          "Chọn công việc phù hợp với lối sống và giá trị cá nhân",
          "Hỗ trợ CV, phỏng vấn và kế hoạch quay lại làm việc",
        ],
      },
      {
        title: "Chuyển Hướng Nghề Nghiệp (Trung Niên)",
        desc: [
          "Đánh giá lại giá trị sống, thế mạnh và ưu tiên cuộc đời",
          "Khám phá hướng đi nghề nghiệp mới, ý nghĩa và thực tế",
          "Lập kế hoạch chuyển đổi bền vững cho 10–15 năm tới",
          "Điều chỉnh công việc phù hợp với con người bạn hiện tại",
        ],
      },
    ],
  },
};
